import {useMutation} from "@tanstack/react-query";

import {editSupplierContactMutationOptions} from "./edit-supplier-contact.mutation-options";

export function useEditSupplierContact(supplierId: string, contactId: number) {
  return useMutation(editSupplierContactMutationOptions(supplierId, contactId));
}
